import React from 'react';
import SearchEngine from '@components/Widgets/SearchEngine';

type HomePageProps = {

}

const HomePage: React.FC<HomePageProps> = () => {
    return <>
        <div className='tw-container tw-mx-auto'>
            <SearchEngine mode="list" />
        </div>
    </>
}

export default HomePage;